import FlipMove from 'react-flip-move'

import { BaseSkeleton } from 'components/BaseSkeleton'
import LoadingErrorWrapper from 'components/LoadingErrorWrapper'
import { NicheCard } from 'modules/niche'

import { NicheCardListSkeleton } from './niche-card-list.skeleton'
import type { TNicheCardListView } from './niche-card-list.types'
import './niche-card-list.styles.scss'

export const NicheCardListView = ({
  niches,
  error,
  loading,
  refetch,
  shouldDisplayAlert,
  shouldDisplayLoading,
  feature,
  hideAddToCheckbox,
  hideRedirectLink,
}: TNicheCardListView) => {
  return (
    <LoadingErrorWrapper error={error} loading={loading} refetch={refetch} skeletonComponent={NicheCardListSkeleton}>
      <div className="NicheCardList">
        <FlipMove enterAnimation="none" leaveAnimation="none" className="NicheCardList-list">
          {niches.map(niche => {
            return (
              <NicheCard
                {...niche}
                shouldDisplayLimitAlert={shouldDisplayAlert}
                feature={feature}
                hideAddToCheckbox={hideAddToCheckbox}
                hideRedirectLink={hideRedirectLink}
                key={niche.territoryId}
              />
            )
          })}
        </FlipMove>
        {shouldDisplayLoading && <BaseSkeleton height="70px" width="300px" borderRadius="12px" key="keleton-niche" />}
      </div>
    </LoadingErrorWrapper>
  )
}
